"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    toolbarIndentLeft: {
        marginLeft: 22,
    },
    dialogWrapper: {
        display: 'flex',
        width: 800,
    },
}));
//# sourceMappingURL=batches-styles.js.map